import Vue from 'vue'
import { getAreaCoordRelativeCenter } from '@/utils/helpers'

const OVERPASS_HOST = 'https://www.overpass-api.de/api/interpreter'
const REQUEST_POINT_LIST =
	'node["amenity"~"^school$|college|hospital|clinic"];' +
	'node["tourism"="attraction"];' +
	'node["industrial"="port"];' +
	'node["landuse"="port|harbour"];' +
	'node["government"];' +
	'node["office"="government"];' +
	'node["highway"="bus_stop"];' +
	'node["railway"="station"];' +
	'node["aeroway"="aerodrome"];'


export default {
	namespaced: true,
	state: {
		list: []
	},
	actions: {
		async getPoints({ commit }, center) {
			let areaCoord = getAreaCoordRelativeCenter(center)
			let response = await Vue.http.get(
				OVERPASS_HOST +
				'?data=[out:json][bbox:' + areaCoord + '];(' + REQUEST_POINT_LIST + ');out%20meta;'
			)
			commit('set', { type: 'list', value: response.body.elements })
		}
	},
	mutations: {
		set(state, { type, value }) {
			state[type] = value
		}
	}
}
